// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'
import Select from 'react-select'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
} from 'data'

// props
type SelectInput816SiteProps = {
    disabled?: boolean
    error: string | undefined
    label: string
    multi?: boolean
    name: string
    onChange: any
    options: { id?: string, value?: string }[]
    placeholder?: string
    value: any
}

// main
export const SelectInput816Site: React.FC<SelectInput816SiteProps> = React.memo(({
    disabled,
    error,
    label,
    multi,
    name,
    onChange,
    options,
    placeholder,
    value,
}) => {

    useEffect(() => {
        // Handle both single values and arrays for multiselect
        if (multi && Array.isArray(value)) {
            setValue(value)
        } else if (!multi && !Array.isArray(value)) {
            setValue(value)
        } else if (multi && !Array.isArray(value)) {
            // Convert single value to array for multiselect
            setValue(value ? [value] : [])
        } else if (!multi && Array.isArray(value)) {
            // Convert array to single value for single select
            setValue(value.length > 0 ? value[0] : null)
        }
    }, [value, multi])

    const dispatch = useDispatch()
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    const deviceType = reduxModalSite.deviceType

    const [newValue, setValue] = useState<any>(value)

    function onInputChange(value: any) {
        try {
            if (value === newValue) return
            setValue(value)
            onChange({
                name: name,
                value: value,
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'SelectInput816Site',
                'onInputChange',
            ))
        }
    }

    const lightCustomStyles = {
        input: (provided: any, state: any) => ({
            ...provided,
            color: 'black',
        }),
        menu: (provided: any, state: any) => ({
            ...provided,
            zIndex: 9999,
        }),
        menuList: (provided: any, state: any) => ({
            ...provided,
            zIndex: 9999,
        }),
        option: (provided: any, state: any) => ({
            ...provided,
            color: state.isSelected ? '#8ea8ff' : 'black',
        }),
        multiValue: (provided: any, state: any) => ({
            ...provided,
            backgroundColor: '#8ea8ff',
            color: 'white',
        }),
        multiValueLabel: (provided: any, state: any) => ({
            ...provided,
            color: 'white',
        }),
        multiValueRemove: (provided: any, state: any) => ({
            ...provided,
            color: 'white',
            ':hover': {
                backgroundColor: '#6b7fd8',
                color: 'white',
            },
        }),
        singleValue: (provided: any, state: any) => ({
            ...provided,
            color: 'black',
        }),
    }

    return (
        <div className={`input-816 select-input-816 ${deviceType}`}>
            <span className={`input-816-label ${deviceType}`}>{label}</span>
            <Select
                getOptionLabel={option => option.value}
                getOptionValue={(option: any) => option.id}
                isClearable
                isDisabled={disabled}
                isMulti={multi}
                name={name}
                onChange={onInputChange}
                options={options}
                placeholder={placeholder || ''}
                styles={lightCustomStyles}
                value={newValue}
            />
            {error && <span className='input-816-error'>{error}</span>}
        </div>
    )
})
